<template>
  <a :class="['big-btn', mutableColor]" :style="computedStyle" @click="onClick">
    Purchase 
  </a>
</template>

<script>
export default {
  components: {},
  props: ['package', 'color', 'fullWidth'],
  data () {
    return {
      mutableColor: this.color || 'grey',
      mutableFullWidth: this.fullWidth || false
    }
  },
  computed: {
    computedStyle () {
      return {
        margin: this.mutableFullWidth ? 'none' : '8px auto'
      }
    },
    currentUser () {
      return this.$store.state.currentUser
    }
  },
  methods: {
    onClick () {
      if (!this.currentUser || !this.currentUser.id) {
        this.$root.$refs.toastr.w('Please log in or register to become a Premium Member')
        return this.$router.push('/register')
      }
      this.$store
        .dispatch("setCurrentPackage", this.package)
      this.$router.push('/purchase')

    }
  }
}
</script>
<style lang="css" scoped>

.big-btn {
  float: none;
  width: 80%;
  height: 100%;
  padding: auto;
  align-self: center;
  text-align: center;
  padding: 0 auto;
  margin-bottom: 11px;
}

.yellow {
  background-color: #f6c657;
  border: #888 1px solid;
}
</style>




// WEBPACK FOOTER //
// purchaseButton.vue?33a3a622